import React from 'react';
const SvgImageThumbnail = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 100 100" width="1em" height="1em" {...props}>
      <path fill="#5C7896" d="M11 3v94h78V23H69V3H11z" />
      <path fill="#769CC2" d="M69 3l20 20H69V3z" />
      <path opacity={0.3} fill="#1B3F63" d="M69 23h20v20L69 23z" />
      <g fill="#FFF">
        <path d="M29 29h42v36H29V29zm-2-2v46h46V27H27z" />
        <path d="M60 49l-5 5 9 9h5v-5zM31 53v10h30L41 43 31 53z" />
        <circle cx={62} cy={38} r={5} />
      </g>
    </svg>
  );
});
export default SvgImageThumbnail;
SvgImageThumbnail.iconName = 'image-thumbnail';
SvgImageThumbnail.displayName = 'SvgImageThumbnail';
